import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import hero1 from "../assets/hero1.jpeg";
import hero2 from "../assets/hero2.jpeg";
import hero3 from "../assets/hero3.jpeg";
import hero4 from "../assets/hero4.jpeg";
import hero5 from "../assets/hero5.jpeg";
import hero6 from "../assets/hero6.jpeg";
import annual6 from "../assets/annual6.JPG";
import img4 from "../assets/image4.JPG";
import img5 from "../assets/image1.JPG";
import img6 from "../assets/primary.png";
import img7 from "../assets/high.png";
import brainfeedImg from "../assets/Brainfeed Magazine Cover page.jpg";
// import { FaWhatsapp } from "react-icons/fa";



import {
  FaLaptopCode,
  FaHandsHelping,
  FaCalculator,
  FaPalette,
  FaComments,
  FaShieldAlt
} from "react-icons/fa";

// ✅ AOS
import AOS from "aos";
import "aos/dist/aos.css";

const PANELS = 4;
const TRANSITION_MS = 900;

const slides = [
  { image: hero1, heading: "Lotus Lap Public School", subheading: "Shaping Bright Futures" },
  { image: hero2, heading: "Excellence in Education", subheading: "Where Every Child Thrives" },
  { image: hero3, heading: "A Legacy of Learning", subheading: "Inspiring Minds Since 1998" },
  { image: hero4, heading: "Holistic Development", subheading: "Nurturing Mind, Body, and Soul" },
  { image: hero5, heading: "State-of-the-art Facilities", subheading: "A Campus Designed for Growth" },
  { image: hero6, heading: "Join Our Community", subheading: "Empowering the Leaders of Tomorrow" },
  { image: annual6, heading: "Annual Day Celebrations", subheading: "A Spectacular Showcase of Talent" },
];

const highlights = [
  { icon: <FaLaptopCode />,   title: "Digital Classrooms", desc: "Interactive smart boards and modern digital teaching methods.",  color: "#1565C0" },
  { icon: <FaHandsHelping />, title: "Life Skills & Value Education", desc: "Building character and discipline.", color: "#6A1B9A" },
  { icon: <FaCalculator />,   title: "Vedic Maths & Abacus", desc: "Enhancing calculation and logic.", color: "#E65100" },
  { icon: <FaPalette />,      title: "Co-curricular Activities", desc: "Arts, music, and creativity.", color: "#2E7D32" },
  { icon: <FaComments />,     title: "Communication Skills", desc: "Boosting confidence and fluency.", color: "#00838F" },
  { icon: <FaShieldAlt />,    title: "Safe Campus", desc: "Secure learning environment.", color: "#C62828" },
];

export default function Home() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const [nextIdx, setNextIdx] = useState(null);
  const [animating, setAnimating] = useState(false);
  const timerRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [showMagazine, setShowMagazine] = useState(false);
  const [branch, setBranch] = useState("saroornagar");
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    classApplying: "",
    message: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEnquirySubmit = (e) => {
    e.preventDefault();
    const { fullName, email, phone, classApplying, message } = formData;
    const whatsappNumber = branch === "karmanghat" ? "9553763144" : "9553741544";
    
    // Construct beautifully formatted message text (completely without emoji icons to prevent diamond symbols)
    const formattedText = `*New School Enquiry*\n\n` +
      `*Name:* ${fullName}\n` +
      `*Email:* ${email}\n` +
      `*Phone:* ${phone}\n` +
      `*Branch:* ${branch === "karmanghat" ? "Karmanghat" : "Saroornagar"}\n` +
      `*Class Applying For:* ${classApplying}\n` +
      `*Message:* ${message || "N/A"}`;
      
    const encodedText = encodeURIComponent(formattedText);
    const whatsappUrl = `https://wa.me/91${whatsappNumber}?text=${encodedText}`;
    
    window.open(whatsappUrl, "_blank");
    
    // Reset form and close
    setFormData({
      fullName: "",
      email: "",
      phone: "",
      classApplying: "",
      message: ""
    });
    setShowForm(false);
  };

  // ✅ MOBILE DETECTION
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ REFRESH AOS
  useEffect(() => {
    AOS.refresh();
  }, []);

  const goTo = useCallback((idx) => {
    if (animating || idx === current) return;
    setNextIdx(idx);
    setAnimating(true);
    setTimeout(() => {
      setCurrent(idx);
      setNextIdx(null);
      setAnimating(false);
    }, TRANSITION_MS + PANELS * 80 + 100);
  }, [animating, current]);

  const goNext = useCallback(() => {
  goTo((current + 1) % slides.length);
}, [current, goTo]);

const goPrev = useCallback(() => {
  goTo((current - 1 + slides.length) % slides.length);
}, [current, goTo]);

  useEffect(() => {
  if (animating) return; // 🚀 prevent overlap

  timerRef.current = setTimeout(() => {
    goNext();
  }, 5500);

  return () => clearTimeout(timerRef.current);
}, [current, animating, goNext]);

  return (
    <div>

      {/* ── HERO ── */}
      <div className="hero-slider">

        {/* ✅ MOBILE / TABLET */}
        {isMobile ? (
          <div className="mobile-slider">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`mobile-slide ${index === current ? "active" : ""}`}
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <div className="slide-overlay" />

                <div className="slide-content">
                  <div className="slide-title-wrapper">
                    <h1 className="slide-title">{slide.heading}</h1>
                  </div>
                </div>
              </div>
            ))}

            <button className="s-arrow s-arrow--l" onClick={goPrev}>&#8249;</button>
            <button className="s-arrow s-arrow--r" onClick={goNext}>&#8250;</button>

            <div className="s-dots">
              {slides.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`s-dot ${i === current ? "s-dot--on" : ""}`}
                />
              ))}
            </div>
          </div>
        ) : (

          /* ✅ DESKTOP (UNCHANGED) */
          <>
            <div className="panel-track">
              {Array.from({ length: PANELS }).map((_, i) => {
                const bgPos = `${(i / (PANELS - 1)) * 100}%`;
                const bgSize = `${PANELS * 100}% auto`;
                const delay = `${i * 80}ms`;

                return (
                  <div key={i} className="panel" style={{ width: `${100 / PANELS}%` }}>
                    <div
                      className={`panel-face panel-face--front ${animating ? "panel-face--exit" : ""}`}
                      style={{
                        backgroundImage: `url(${slides[current].image})`,
                        backgroundSize: bgSize,
                        backgroundPosition: `${bgPos} center`,
                        animationDelay: delay,
                      }}
                    />
                    {nextIdx !== null && (
                      <div
                        className={`panel-face panel-face--back ${animating ? "panel-face--enter" : ""}`}
                        style={{
                          backgroundImage: `url(${slides[nextIdx].image})`,
                          backgroundSize: bgSize,
                          backgroundPosition: `${bgPos} center`,
                          animationDelay: delay,
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </div>

            <div className="slide-overlay" />

            <div className="slide-content" key={current}>
              <div className="slide-title-wrapper">
                <h1 className="slide-title">{slides[current].heading}</h1>
              </div>
            </div>

            <button className="s-arrow s-arrow--l" onClick={() => goTo((current - 1 + slides.length) % slides.length)}>&#8249;</button>
            <button className="s-arrow s-arrow--r" onClick={() => goTo((current + 1) % slides.length)}>&#8250;</button>

            <div className="s-dots">
              {slides.map((_, i) => (
                <button
                  key={i}
                  onClick={() => goTo(i)}
                  className={`s-dot ${i === current ? "s-dot--on" : ""}`}
                />
              ))}
            </div>
          </>
        )}
      </div>

     
 {/* ── ABOUT TITLE ── */}
      <div className="about-title-center" data-aos="fade-up">
        <h2>About Lotus Lap Public School</h2>
      </div>

      {/* ── ABOUT ── */}
      <div className="about-modern">

        <div className="about-image" data-aos="fade-right">
          <img src={img4} alt="Students Learning" />
        </div>

        <div className="about-content" data-aos="fade-left">

          <p>
            Lotus Lap Public School is dedicated to creating a nurturing and inspiring
            learning environment where every child is encouraged to grow academically,
            socially, and emotionally. The school believes in providing a strong
            foundation that helps students become confident individuals ready to face
            the challenges of the future.
          </p>

          <p>
            With a focus on quality education and modern teaching practices, the school
            blends traditional values with innovative learning methods. Students are
            guided to think independently, explore their creativity, and develop a deep
            understanding of concepts rather than just memorizing them.
          </p>

          <p>
            At Lotus Lap, equal importance is given to discipline, values, and personal
            growth. The school aims to shape responsible citizens by fostering respect,
            integrity, and a love for learning in every student.
          </p>

        </div>
      </div>

      {/* ── HIGHLIGHTS ── */}
      <div className="highlights-section">
        <h2 data-aos="fade-up">Our Highlights</h2>

        <div className="highlights-grid">
          {highlights.map((item, index) => (
            <div
              className="highlight-card"
              key={index}
              style={{ "--card-color": item.color }}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div className="highlight-icon-wrap">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ── ACADEMICS ── */}
      <div className="acad-section">
        <h2 data-aos="fade-up">Academic Excellence at Every Level</h2>

        <p className="acad-desc">
          Structured learning paths designed for every stage of a child's growth.
        </p>

        <div className="acad-hover-grid">

          <div className="acad-hover-card">
            <img src={img5} alt="Pre Primary" />
            <div className="acad-overlay">
              <h3>Pre-Primary</h3>
              <p>PG • PP1 • PP2 • Grade 1</p>
            </div>
          </div>

          <div className="acad-hover-card">
            <img src={img6} alt="Primary" />
            <div className="acad-overlay">
              <h3>Primary</h3>
              <p>Grades 1 - 5 • Core Subjects</p>
            </div>
          </div>

          <div className="acad-hover-card">
            <img src={img7} alt="High School" />
            <div className="acad-overlay">
              <h3>High School</h3>
              <p>Classes 6 to 10 • Advanced subjects</p>
            </div>
          </div>

        </div>

        {/* ── SLOGAN ── */}
        <div className="slogan-section">
          <div className="slogan-content">

            <h2>“Vidwan Sarwatra Pujyathe”</h2>

            <p>
              A person with knowledge is respected everywhere. At Lotus Lap Public School,
              we strive to empower students with wisdom, values, and confidence that
              earn them recognition in every walk of life.
            </p>

            <button
              className="slogan-btn"
              onClick={() => navigate("/contact")}
            >
              Get In Touch
            </button>

          </div>
        </div>

      </div>
{/* FLOATING BUTTONS */}
<div className="floating-buttons">

  {/* Brainfeed Magazine Button */}
  <button
    className="float-btn brainfeed-btn"
    onClick={() => setShowMagazine(true)}
  >
    Brainfeed Magazine
  </button>

  {/* Enquiry Button */}
 <button
  className="float-btn enquiry-btn"
  onClick={() => setShowForm(true)}
>
  Enquiry
</button>

  {/* WhatsApp Button */}
  {/* <a
    href="https://wa.me/919XXXXXXXXX"  // 👉 replace with your number
    target="_blank"
    rel="noopener noreferrer"
    className="float-btn whatsapp-btn"
  >
    <FaWhatsapp />
  </a> */}

</div>
{showForm && (
  <div className="popup-overlay" onClick={() => setShowForm(false)}>
    
    <div
      className="popup-form"
      onClick={(e) => e.stopPropagation()}
    >
      
     <button className="close-btn" onClick={() => setShowForm(false)}>
  &times;
</button>

      <h2>Enquiry Form</h2>

<div className="branch-switch">

  <button
    className={branch === "saroornagar" ? "active" : ""}
    onClick={() => setBranch("saroornagar")}
  >
    Saroornagar Branch
  </button>

  <button
    className={branch === "karmanghat" ? "active" : ""}
    onClick={() => setBranch("karmanghat")}
  >
    Karmanghat Branch
  </button>

</div>

<form onSubmit={handleEnquirySubmit}>

  <input
    type="text"
    name="fullName"
    placeholder="Full Name"
    value={formData.fullName}
    onChange={handleInputChange}
    required
  />

  <input
    type="email"
    name="email"
    placeholder="Email Address"
    value={formData.email}
    onChange={handleInputChange}
    required
  />

  <input
    type="tel"
    name="phone"
    placeholder="Phone Number"
    value={formData.phone}
    onChange={handleInputChange}
    required
  />

  <input
    type="text"
    value={
      branch === "saroornagar"
        ? "Saroornagar Branch"
        : "Karmanghat Branch"
    }
    readOnly
  />

  <input
    type="text"
    name="classApplying"
    placeholder="Class Applying For"
    value={formData.classApplying}
    onChange={handleInputChange}
    required
  />

  <textarea
    name="message"
    placeholder="Your Message"
    rows="5"
    value={formData.message}
    onChange={handleInputChange}
  ></textarea>

  <button type="submit">
    Submit Enquiry
  </button>

</form>

    </div>
  </div>
)}

{showMagazine && (
  <div className="popup-overlay" onClick={() => setShowMagazine(false)}>
    <div
      className="popup-magazine"
      onClick={(e) => e.stopPropagation()}
    >
      <button className="close-btn" onClick={() => setShowMagazine(false)}>
        &times;
      </button>
      <div className="magazine-content">
        <img
          src={brainfeedImg}
          alt="Brainfeed Magazine Cover Page"
          className="magazine-cover-img"
        />
      </div>
    </div>
  </div>
)}
    </div>
    
  );
}